import React, { useEffect, useState } from 'react'
import Title from '../../components/common/Title'
import { Topbar } from '../../components/include/Topbar'
import { useNavigate } from 'react-router-dom'
import DeleteModal from '../../components/common/DeleteModal'
import { Postdata } from '../../helpers/api.service'
import HttpService from '../../helpers/httpServices'
import { message } from '../../redux/actions/toastActions'
import { useDispatch, useSelector } from 'react-redux'
import Error403Page from '../ErrorPage'
import { isPermission, isRole } from '../../redux/selectors/authSelector'

const Roles = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([])
    const dispatch = useDispatch()
    const [loader, setLoader] = useState(false)
    const [refresh, setRefresh] = useState(false)
    const [modalOpenDelete, setmodalOpenDelete] = useState(false);
    const [modalOpenDeleteSuccess, setModalOpenDeleteSuccess] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [openCardId, setOpenCardId] = useState(null);
    const permissions = useSelector(isPermission);
    const role = useSelector(isRole)
    console.log("permissions", permissions)
    const isAccessible = role == "schooladmin" || permissions && permissions?.includes('view_Roles') || false;



    const handleToggle = (id) => {
        setOpenCardId(prevId => (prevId === id ? null : id));
    };



    const fetchData = () => {
        setLoader(true);
        Postdata(HttpService.school_role_list).then((res) => {
            if (res.status === 200) {
                setData(res.data);
            } else {

                dispatch(message(res.message));
            }
            setLoader(false)
        });
    }

    const handleDelete = (id) => {
        setLoader(true)
        Postdata(HttpService.school_role_delete, { id: id }).then((res) => {
            if (res.status === 200) {
                setRefresh(!refresh);
            }
            else {
                dispatch(message(res.message));
            }
            setLoader(false)
        });
    }
    useEffect(() => {
        fetchData();
    }, [refresh])

    if (!isAccessible) {
        return (
            <>
                <Error403Page />
            </>
        );
    }
    return (
        <>
            <Title name="Roles & Permissions" />
            <Topbar title='Roles & Permissions' />
            <div className="p-6 space-y-6 pr-0">
                <div className='flex justify-end'>

                    <button
                        className={`button-small-primary`}
                        onClick={() => navigate(`/role/add`)}
                    >
                        + Add Roles
                    </button>
                </div>
                <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3'>

                    {data.length > 0 && data.map((item, index) =>
                    (
                        <div className=' rounded-lg  p-4' key={index}>
                            {/* Header */}
                            <div className="bg-white p-4 flex justify-between items-center cursor-pointer " onClick={() => handleToggle(item._id)}>
                                <h3 className="text-sm font-semibold text-gray-800">
                                    {item.name}
                                </h3>
                                <svg
                                    className={`w-5 h-5 transform transition-transform duration-300 ${openCardId === item._id ? 'rotate-180' : 'rotate-0'}`}
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    viewBox="0 0 24 24"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                </svg>
                            </div>

                            {/* Expanded Permissions */}
                            {openCardId === item._id && (
                                <div className='bg-white p-4 ' >
                                    {/* Permissions */}
                                    <div className=" space-y-1 text-sm text-gray-600">
                                        {item.permissions && item.permissions.length > 0 ? (
                                            item.permissions.map((permission, idx) => (
                                                <div key={idx}>{permission.replace(/_/g, ' ')}</div>
                                            ))
                                        ) : (
                                            <div>No permissions assigned</div>
                                        )}
                                    </div>

                                    {/* Action Buttons */}
                                    <div className="flex gap-2 mt-4">
                                        <button
                                            onClick={() => navigate(`/role/edit/${item._id}`, { state: { type: "edit" } })}
                                            className="flex-1 bg-primary_main text-white text-sm py-2 rounded hover:bg-purple-700 transition"
                                        >
                                            Edit
                                        </button>
                                        <button
                                            onClick={() => {
                                                setSelectedId(item._id);
                                                setmodalOpenDelete(true);
                                            }}
                                            className="flex-1 bg-red-600 text-white text-sm py-2 rounded hover:bg-red-700 transition"
                                        >
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            )}


                            {/* Action Buttons */}
                        </div>
                    )
                    )
                    }
                    <DeleteModal
                        title="Delete Role"
                        message="Are you sure you want to delete Role?
It will erase all the data permanently."
                        modalOpenDelete={modalOpenDelete}
                        setmodalOpenDelete={setmodalOpenDelete}
                        handleDelete={handleDelete} // Don't call it here
                        selectedId={selectedId}
                        setSelectedId={setSelectedId}
                        modalOpenDeleteSuccess={modalOpenDeleteSuccess}
                        setModalOpenDeleteSuccess={setModalOpenDeleteSuccess}
                        module={"Role"}
                        redirectPage={"Roles & Permissions"}
                        redirectUrl={'/role'}
                    />
                </div>
                {
                    data.length === 0 && <div className="h-[50vh] flex items-center justify-center w-full">
                        <h1 className="text-center text-gray-400">No Data Found</h1>
                    </div>
                }
            </div>
        </>
    )
}

export default Roles